import {
  watchInitAssignmentsTab,
  watchGetSlimReportingData,
  workPollingManager,
  watchToggleWorkDetails
} from './assignmentsTabSagas';
import {
  watchRequestInitialBinderData,
  watchUnloadBinderData,
} from './binderSagas';
import {watchInitCcAnchorStandards} from './ccAnchorStandardsSagas';
import {
  watchRemoveStudentQuiz,
  watchSaveRevisionRequest,
} from './studentActivitySagas';
import {watchBinderStudentDetails} from './studentDetailsSagas';
import {watchInitStudentTab} from './studentTabSagas';

const binderSagas = [
  watchBinderStudentDetails,
  watchGetSlimReportingData,
  watchInitAssignmentsTab,
  watchInitStudentTab,
  watchRemoveStudentQuiz,
  watchRequestInitialBinderData,
  watchSaveRevisionRequest,
  watchToggleWorkDetails,
  watchUnloadBinderData,
  workPollingManager,
  watchInitCcAnchorStandards,
];

export default binderSagas;
